import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, scroll the window to the top.
 * Place inside <BrowserRouter> tree.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
